import React from 'react';

interface Button {
  id: string;
  url: string;
  text: string;
  type: string;
  newTab: boolean;
}

export interface BreadcrumbProps {
  items: Button[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  return (
    <div className="flex justify-center">
      <div className="max-w-6xl w-full mx-4" style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
        <ul className="flex lg text-left">
          {items.map((item, index) => (
            <li key={item.id} className="flex items-center">
              <a
                href={item.url}
                target={item.newTab ? '_blank' : '_self'}
                rel={item.newTab ? 'noopener noreferrer' : undefined}
                className="font-medium max-sm:text-xl max-sm:whitespace-nowrap md:text-[20px] md:leading-[45px] tracking-[0] text-[#032d60] text-left max-sm:text-center hover:text-blue-600"
              >
                {item.text}
              </a>
              {index < items.length - 1 && (
                <svg className="rtl:rotate-180 w-4 h-4 text-blue-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4" />
                </svg>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Breadcrumb;
